const MatchPlayType = {
	Big18: 0,
	Front9: 1,
	Back9: 2
}

export default MatchPlayType;
